import React from "react";
import { motion } from "framer-motion";
import {
  FaCogs,
  FaCheckCircle,
  FaServer,
  FaCode,
  FaLightbulb,
} from "react-icons/fa";
import "./SoftwareDevelopment.scss";
import ServicesCommon from "../ServicesCommon/ServicesCommon";
import { useNavigate } from "react-router-dom";
import SoftwareDevImg from "../../../assets/images/softwaredevelopment.png";

// --- Framer Motion Variants ---

const sectionFade = {
  hidden: { opacity: 0, y: 50 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: [0.17, 0.55, 0.55, 1] },
  },
};

const listContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.15 },
  },
};

const listItem = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 },
};

const SoftwareDevelopment = () => {
  const navigate = useNavigate();

  return (
    <div className="software-dev-page-soft">
      {/* ------------------ 1. HERO SECTION ------------------ */}
      <section className="hero-section-soft">
        <div className="hero-content-left-soft">
          <motion.p
            className="hero-tag-soft"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 0.2 }}
          >
            SOFTWARE DEVELOPMENT
          </motion.p>

          <motion.h1
            className="hero-title-soft"
            variants={sectionFade}
            initial="hidden"
            animate="visible"
          >
            We Implement Your Ideas into{" "}
            <motion.span
              initial={{ color: "#333" }}
              animate={{ color: "#FF6B6B" }}
              transition={{
                duration: 1.5,
                repeat: Infinity,
                repeatType: "mirror",
              }}
            >
              Interactive Software
            </motion.span>
          </motion.h1>

          <motion.p
            className="hero-subtext-soft"
            variants={listItem}
            initial="hidden"
            animate="visible"
          >
            Over 13+ years working in IT services developing powerful software
            applications and mobile apps for clients worldwide.
          </motion.p>

          <motion.p
            className="hero-desc-soft"
            variants={listItem}
            initial="hidden"
            animate="visible"
          >
            Econsign Soft has a track record of delivering dependable, scalable
            software solutions that add tremendous value to your business. We
            offer expertise across education, finance, insurance, healthcare,
            logistics, and many more domains.
          </motion.p>

          <motion.button
            className="primary-btn-soft"
            variants={listItem}
            initial="hidden"
            animate="visible"
            whileHover={{
              scale: 1.05,
              boxShadow: "0 10px 30px rgba(255, 107, 107, 0.4)",
            }}
            whileTap={{ scale: 0.98 }}
            onClick={() => navigate("/contact-us")}
          >
            Contact Us
          </motion.button>
        </div>

        {/* ------------------ Illustration ------------------ */}
        <motion.div
          className="dev-floating-illustration-soft"
          initial={{ opacity: 0, x: 50, rotate: 5 }}
          animate={{ opacity: 1, x: 0, rotate: 0 }}
          transition={{ duration: 1.2, delay: 0.5, type: "spring", stiffness: 100 }}
        >
          <div className="illustration-core-soft">
            <img
              src={SoftwareDevImg}
              alt="Software Development Illustration"
              className="responsive-dev-img-soft"
            />
          </div>
        </motion.div>
      </section>

      {/* ------------------ 2. PROCESS / WORKFLOW ------------------ */}
      <section className="dev-process-section-soft">
        <motion.h2
          variants={sectionFade}
          initial="hidden"
          whileInView="visible"
          className="agile-h2"
          viewport={{ once: true }}
        >
          Our <span className="highlight-process-soft">Agile</span> Software
          Development Cycle
        </motion.h2>

        <motion.div
          className="dev-process-timeline-soft"
          variants={listContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          {[
            {
              icon: FaLightbulb,
              title: "Requirement Analysis & Planning",
              detail:
                "Defining scope, gathering functional needs, and creating a strategic roadmap.",
            },
            {
              icon: FaCogs,
              title: "UX/UI Designing & Prototyping",
              detail:
                "Creating engaging interfaces and user flows for seamless experience.",
            },
            {
              icon: FaCode,
              title: "Development & Integrations",
              detail:
                "Writing clean, scalable code and integrating third-party services.",
            },
            {
              icon: FaCheckCircle,
              title: "Testing & Quality Assurance (QA)",
              detail:
                "Rigorous manual and automated testing to ensure a bug-free product.",
            },
            {
              icon: FaServer,
              title: "Deployment & Maintenance",
              detail:
                "Launching the application and providing ongoing support and updates.",
            },
          ].map((step, i) => (
            <motion.div className="process-step-soft" key={i} variants={listItem}>
              <div className="step-number-wrapper-soft">
                <span className="step-number-soft">{i + 1}</span>
                <step.icon className="step-icon-soft" />
              </div>
              <div className="step-content-soft">
                <h3>{step.title}</h3>
                <p>{step.detail}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </section>

      {/* ------------------ 3. COMMON SECTION ------------------ */}
      <ServicesCommon />
    </div>
  );
};

export default SoftwareDevelopment;